import MazeDesign from "./MazeDesign.js";

export default class CellDesign {
	constructor(row, col) {
		this.row = row;
		this.col = col;
		this.rowRoom = -1;
		this.colRoom = -1;
		this.walls = [CellDesign.MURO, CellDesign.MURO];
		this._visited = false;
		this._room = CellDesign.NOT_BELONG_TO_A_ROOM;
		this._exit = false;
		this._start = false;
		this._end = false;
		this._label = " ";
		this._depthIndex = -1;
		this._pathIndex = -1;
		this.id = CellDesign.IDS++;
	}

	hasWall(dir) {
		if (this.walls[dir] === CellDesign.MURO) {
			return true;
		}
		return false;
	}



	removeWall(dir) {
		if (dir === MazeDesign.DIR_E) {
			this.walls[CellDesign.WALL_E] = CellDesign.APERTO;
		}
		if (dir === MazeDesign.DIR_S) {
			this.walls[CellDesign.WALL_S] = CellDesign.APERTO;
		}
	}

	setWall(dir, value) {
		this.walls[dir] = value;
	}

	isRoom() {
		if (this.room !== CellDesign.NOT_BELONG_TO_A_ROOM) {
			return true;
		}
		return false;
	}

	get visited() {
		return this._visited;
	}
	set visited(value) {
		this._visited = value;
	}

	get room() {
		return this._room;
	}
	set room(value) {
		this._room = value;
	}

	get exit() {
		return this._exit;
	}
	set exit(value) {
		this._exit = value;
	}

	get start() {
		return this._start;
	}
	set start(value) {
		this._start = value;
	}

	get end() {
		return this._end;
	}
	set end(value) {
		this._end = value;
	}

	get label() {
		return this._label;
	}
	set label(value) {
		this._label = value;
	}

	get depthIndex() {
		return this._depthIndex;
	}
	set depthIndex(value) {
		this._depthIndex = value;
	}

	get pathIndex() {
		return this._pathIndex;
	}
	set pathIndex(value) {
		this._pathIndex = value;
	}

}

CellDesign.WALL_E = 0;
CellDesign.WALL_S = 1;

CellDesign.APERTO = 0;
CellDesign.MURO = 1;

CellDesign.IDS = 0;
CellDesign.NOT_BELONG_TO_A_ROOM = -1;